const $ = require("cash-dom");
/*
* NOTICE: if your element changing ".active" class on click somewhere - use 'mousedown' event with e.preventDefault(); instead of 'click' event. Example: FAQ
*/
class KeyboardNavigation {
	constructor({$rootLinks, closestSelectorToPreventToHideMenu, rootLinkContainerSelector}) {
		this._$rootLinks = $rootLinks;
		this._closestSelectorToPreventToHideMenu = closestSelectorToPreventToHideMenu;
		this._rootLinkContainerSelector = rootLinkContainerSelector;
	}

	init() {
		const self = this;

		$('a, button, select, input, [tabindex="0"]').on('focus', function () {
			const $el = $(this);

			if (!$el.closest(self._closestSelectorToPreventToHideMenu).length) {
				self._removeAllActiveClasses();
			}
		});

		self._$rootLinks.on('focus', function (e) {
			const $navLink = $(this);

			self._addClassActive($navLink);
		});

		$(document).on('click', function (e) {
			const $el = $(e.target);

			if (!$el.hasClass('unfocusable-click')) {
				self._removeAllActiveClasses();
			}
		});
	}

	_addClassActive($navLink) {
		if (!$navLink || !$navLink.length) {
			return;
		}

		const $navLinkContainer = this._rootLinkContainerSelector !== null
			? $navLink.closest(this._rootLinkContainerSelector)
			: $navLink;

		$navLinkContainer.addClass('active');
	}

	_removeClassActive($navLink) {
		if (!$navLink || !$navLink.length) {
			return;
		}

		const $navLinkContainer = this._rootLinkContainerSelector !== null
			? $navLink.closest(this._rootLinkContainerSelector)
			: $navLink;

		$navLinkContainer.removeClass('active');
	}

	_removeAllActiveClasses() {
		this._$rootLinks.each((i, navLink) => {
			const $navLink = $(navLink);

			this._removeClassActive($navLink);
		});
	}
}

$(function () {
	const $navLinks = $('ul.navbar-nav > li.nav-item > .nav-link');

	if ($navLinks.length) {
		(new KeyboardNavigation({
			$rootLinks: $navLinks,
			closestSelectorToPreventToHideMenu: '.sub-menu',
			rootLinkContainerSelector: 'li.nav-item',
		})).init();
	}

	const customSelects = $('#header_currencies, #header_languages');

	if (customSelects.length) {
		(new KeyboardNavigation({
			$rootLinks: customSelects,
			closestSelectorToPreventToHideMenu: '.options',
			rootLinkContainerSelector: null,
		})).init();
	}

	const faq = $('#faq .single-qa');

	if (faq.length) {
		(new KeyboardNavigation({
			$rootLinks: faq,
			closestSelectorToPreventToHideMenu: '.answer',
			rootLinkContainerSelector: null,
		})).init();
	}
});
